import { isArray } from 'lodash';
import queryString from 'qs';

const getScheduleLiveAccountPayload = (payload) => {
  const queries = {
    accountType: '[1, 2]',
  };
  if (payload.brand) queries['accountLivestreams.brands.name'] = !isArray(payload.brand) ? [payload.brand.value] : payload?.brand?.map((item) => item.value);
  if (payload.platform) {
    queries['accountLivestreams.ecommerce.id'] = !isArray(payload.platform) ? [payload.platform.value] : `[${payload?.platform?.map((item) => item.value)}]`;
  }

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getScheduleLiveAccountPayload;
